import { formatDateToShortFormat } from "../../../utils/IGdateTimeFunctions";

const PeriodHeader = ({ title, date, startDate, endDate, league, className, leagueClassName }) => {
  const start = startDate ?? date;
  const end = endDate ?? (startDate ? null : date);
  const startFormatted = start ? formatDateToShortFormat(start) : null;
  const endFormatted = end ? formatDateToShortFormat(end) : null;

  return (
    <section
      className={`mb-6 flex w-full min-w-[300px] items-center justify-between px-2 font-bold italic ${className}`}
    >
      <div>
        <h1 className="text-3xl">{title}</h1>
        {league && (
          <h2 className={`font-league text-xl ${leagueClassName}`}>{league}</h2>
        )}
      </div>
      <div className="text-center not-italic">
        {startFormatted && (
          <p className="underline underline-offset-4">
            {startFormatted}
          </p>
        )}
        {endFormatted != null && endFormatted !== startFormatted && (
          <p>{endFormatted}</p>
        )}
      </div>
    </section>
  );
};

export default PeriodHeader;
